import React from "react";
function Faq() {
  return <div className="container m-auto p-4 md:py-6">faq</div>;
}
export default Faq;
